<script lang="ts">
	import classNames from 'classnames';
	import ButtonLoading from './ButtonLoading.svelte';
	import {
		buttonSizeClasses,
		baseButtonClass,
		type ButtonSize,
		type ButtonType,
		type ButtonLoadingMode
	} from './button';

	export let textGreyed = false;
	export let disabled = false;
	export let mode: 'fill' | 'outline' | 'outline-thin' | 'error' = 'fill';
	export let loading: ButtonLoadingMode = 'off';
	export let size: ButtonSize = 'md';
	export let type: ButtonType = 'submit';
	export let ariaLabel = 'button';

	$: showDisabledStyle = disabled || loading !== 'off';

	function background() {
		if (mode === 'outline') {
			return showDisabledStyle
				? 'border-2 -mx-[2px] border-info'
				: 'border-2 -mx-[2px] cta-border-gradient focus-visible:ring-inset focus-visible:ring-pink focus-visible:ring-2';
		} else if (mode === 'outline-thin') {
			return showDisabledStyle
				? 'border -mx-[1px] border-info'
				: 'border -mx-[1px] cta-border-gradient focus-visible:ring-inset focus-visible:ring-pink focus-visible:ring-2';
		} else if (mode === 'error') {
			return showDisabledStyle ? 'bg-neutral' : 'bg-error';
		} else {
			return showDisabledStyle
				? 'bg-gradient-to-br from-neutral to-base-100'
				: 'cta-gradient focus-visible:ring-white focus-visible:ring-2 focus-visible:ring-inset';
		}
	}

	function getTextColor() {
		if (showDisabledStyle || textGreyed) {
			return 'text-info';
		}
		return 'text-base-content';
	}

	$: classes = classNames(
		baseButtonClass,
		background(),
		getTextColor(),
		buttonSizeClasses[size],
		$$props.class
	);

	let buttonElement: HTMLButtonElement;
</script>

<button
	{type}
	class={classes}
	disabled={showDisabledStyle}
	style={$$props.style}
	data-test-id={$$props['data-test-id']}
	bind:this={buttonElement}
	on:click
	on:click={() => buttonElement.blur()}
	on:change
	on:keydown
	on:keyup
	on:mouseenter
	on:mouseleave
	aria-label={ariaLabel}
>
	{#if loading === 'hide-content'}
		<span class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
			<ButtonLoading {size} />
		</span>
		<span class="invisible"><slot /></span>
	{:else if loading === 'left-content'}
		<ButtonLoading {size} />
		<span class="pl-2"><slot /></span>
	{:else if loading === 'right-content'}
		<span class="pr-2"><slot /></span>
		<ButtonLoading {size} />
	{:else}
		<slot />
	{/if}
</button>
